import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import { Formik } from "formik";
// import AddVendor from './addDriverV2';
// import FreightDetails from './FreightDetails';
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import SvgImage from "../../../Icons/Icons";
import DatePicker from "react-datepicker";
import { DatePickerField } from "../../../core/inputs/input";
import { useRef } from "react";
import {
  storeMedia,
  toastStatus,
} from "../../../../services/Store/Actions/appActions";
import { useEffect } from "react";
import { addDriverV2 } from "../../../../services/Store/Actions/TripsAction";
import { getDriverList } from "../../../../services/Store/Actions/driverslistActions";
import {
  createVendorAction,
  getVendorAction,
} from "../../../../services/Store/Actions/beneficiaryAction";
import ConfirmationModal from "../../../subComponents/confirmModal";

function AddVendor(props) {
  const { toggle, freight, setFreight, onSuccess,confirm, setConfirm } = props;
  const dispatch = useDispatch();
  const [status1, setStatus1] = useState(false);
  const [status2, setStatus2] = useState(false);
  const [status3, setStatus3] = useState(false);
  const [status4, setStatus4] = useState(false);
  const [displayName1, setDisplayName1] = useState([]);
  const [displayName2, setDisplayName2] = useState([]);
  const [displayName3, setDisplayName3] = useState([]);
  const [displayName4, setDisplayName4] = useState([]);

  const closeBtn = (
    <button
      className="close"
      style={{
        width: "35px",
        height: "35px",
        borderRadius: "50%",
        backgroundColor: "#FFF",
        borderColor: "#2E7C7B",
        display: "flex",
        justifyContent: "space-evenly",
      }}
      onClick={toggle}
      type="button"
    >
      <div className="x">X</div>
    </button>
  );
  //   const validationSchema = Yup.object().shape({
  //     phone: Yup.number(10)
  //       .required("Required"),
  //     fullName : Yup.string()
  //     .required("Required"),
  //   });
  const handleCloseFreight = () => {
    setFreight(!freight);
  };

  return (
    <div>
      <Modal
        isOpen={freight}
        onHide={handleCloseFreight}
        className="all-transaction-main-modal"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          className="transactionModalBody"
          style={{ marginTop: "25px" }}
        >
          <div className="PGCollectionBox">
            <div className=/*"PGCollectionclose */ "closeEffectRow close-btn-for-transaction">
              <div className="closeEffect" onClick={toggle}>
                <SvgImage
                  classname="close-btn-text"
                  style={{ width: "10%", height: "10%" }}
                  name="CloseButtonLogo"
                  width="20%"
                  height="20%"
                />
              </div>
            </div>
            <div
              className="PGCollectiontText col-9"
              style={{ marginLeft: "50px" }}
            >
              Add Vendor
            </div>
            <Formik
              enableReinitialize
              //   validationSchema={validationSchema}
              initialValues={{
                phone: "",
                name: "",
                // dlFront: "",
                // dlBack: "",
                // aadharFront: "",
                // aadharBack: "",
              }}
              onSubmit={(values) => {
                console.log("driverDetails", values);
                dispatch(
                  createVendorAction(
                    { ...values, isDummy: 1, vendorType: "2" },
                    (res) => {
                      console.log("asdasdasdsad ",res);
                      if (res?.status == 200) {
                        console.log("ssffsafasfeae ",res?.data?.data);
                        onSuccess(res?.data?.data);
                        toggle()
                        setConfirm(true);
                      }
                    }
                  )
                );
              }}
            >
              {({
                handleBlur,
                handleChange,
                handleSubmit,
                values,
                touched,
                isValid,
                errors,
                setFieldValue,
              }) => (
                <Form
                  onSubmit={handleSubmit}
                  style={{ marginTop: "50px", padding: "0 75px 0 50px" }}
                >
                  <FormGroup
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "30px",
                    }}
                  >
                    <FormGroup>
                      <div className="row">
                        <div className="col-6 row">
                          <div className="col-12">
                            <label for="vrn" className="heading3 semiBold">
                              Vendor Name
                            </label>
                          </div>
                          <div className="col-12" style={{ padding: "8px" }}>
                            <input
                              type="text"
                              id="tripNo"
                              className={`inputBoxAddCust ${
                                touched.name && errors.name ? "is-invalid" : ""
                              }`}
                              name="name"
                              value={values.name}
                              onChange={handleChange("name")}
                              onBlur={handleBlur("name")}
                              touched={touched.name}
                              errors={errors.name}
                              placeholder="Contact Person Name"
                            />
                            <div
                              style={{ margin: "7px 0 0px 5px", color: "red" }}
                            >
                              {errors.name && touched.name ? (
                                <div>*{errors.name}</div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="col-6 row">
                          <div className="col-12">
                            <label for="vrn" className="heading3 semiBold">
                              Phone
                            </label>
                          </div>
                          <div className="col-12" style={{ padding: "8px" }}>
                            <input
                              type="text"
                              id="phone"
                              className={`inputBoxAddCust ${
                                touched.phone && errors.phone
                                  ? "is-invalid"
                                  : ""
                              }`}
                              style={{ background: "#2E7C7B0D" }}
                              name="phone"
                              value={values.phone}
                              onChange={handleChange("phone")}
                              onBlur={handleBlur("phone")}
                              touched={touched.phone}
                              errors={errors.phone}
                              placeholder="Phone"
                            />
                            <div
                              style={{ margin: "7px 0 0px 5px", color: "red" }}
                            >
                              {errors.phone && touched.phone ? (
                                <div>*{errors.phone}</div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                    {/* {confirm ? (
                      <ConfirmationModal
                        isOpen={confirm}
                        onHide={onHide}
                        toggleModal={toggleConfirmModal}
                        handleClose={handleConfrimClose}
                        onPress={() => {
                          handleConfrimClose();
                        }}
                        msg={
                          `Do You want to add this vehicle on ${values.name} Permanently`
                        }
                      />
                    ) : (
                      <></>
                    )} */}
                  </FormGroup>
                  <FormGroup
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "25px",
                      marginTop: "100px",
                    }}
                  >
                    <Button
                      style={{ width: "25%" }}
                      className="notGenerateOpt text4 Medium btn btn-secondary"
                      onClick={toggle}
                    >
                      Back
                    </Button>
                    <Button
                      type="submit"
                      style={{ width: "25%" }}
                      className="generateOtp text3 Medium btn btn-secondary"
                      // onClick={toggle}
                    >
                      Next
                    </Button>
                  </FormGroup>
                </Form>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>

      {/* <AddVehicle1
        toggle = {toggleAddVehicle1}
        modal ={vehicle}
      //   className={className}
      /> */}
      {/* <AddDriverV2
         toggle = {toggleAddDriverV2}
         modal  = {driverV2}
      />
      <FreightDetails
          toggle = {toggleFreightDetails}
          modal  = {fr_Details}
      /> */}
    </div>
  );
}

export default AddVendor;
